import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UxService } from '~/app/core/services';
import { RoleService } from '../../core/services';
import { Device } from '../models/device.model';
import { AmsApi } from './ams-api.base';

@Injectable()
export class DeviceService extends AmsApi<Device> {
  constructor(
    http: HttpClient,
    roleService: RoleService,
    uxService: UxService) {
    super('devices', http, roleService, uxService);
  }
}
